// extracted by mini-css-extract-plugin
export default {"backbox":"style_backbox__Dr7FB","upbox":"style_upbox__7Xaf3","active":"style_active__0pguk","box":"style_box__-JH5v","muneList":"style_muneList__6EQEa"};